export default __webpack_public_path__ + "static/media/cross.879d064e.svg";